import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';
import { getCloudinaryUrl } from '../../services/cloudinary';

type BackgroundImageProps = {
  backgroundImage: string;
};

export const AppPromoContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h2,
  h3[data-id='app-promo-text'] {
    color: #ffffff;
  }

  h3[data-id='app-promo-text'] {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
  }

  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
    flex-direction: row;

    position: relative;
    z-index: 0;

    & :before,
    & :after {
      z-index: -1;
      position: absolute;
      content: ' ';
      display: block;
      width: 330px;
      height: 330px;
      background: transparent url(${getCloudinaryUrl('34b700947ef7681af6a08090a85e1d2a01b315fe')})
        no-repeat;
      background-size: 100%;
    }

    & :before {
      background-position: top -132px left -136px;
      left: -40px;
      top: -64px;

      @media (min-width: ${BREAK_POINTS.Min.LG}) {
        background-position: top -132px left 0;
        left: 0;
        top: -96px;
      }
    }

    & :after {
      display: none;
    }

    @media (min-width: ${BREAK_POINTS.Min.XL}) {
      & :after {
        display: block;
        right: -350px;
        bottom: -108px;
        height: 229px;
      }
    }
  }

  @media (min-width: ${BREAK_POINTS.Min.MD}) and (max-width: ${BREAK_POINTS.Max.LG}) {
    & [data-id^='awards'] {
      display: flex;
      border-radius: 8px;
      padding: 8px 4px 8px 12px;
      max-width: 21em;
      & > * {
        text-align: left;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;
  padding-top: 48px;

  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
  }

  & svg {
    height: 44px;
  }

  > *:nth-child(2) {
    margin-left: 16px;
  }
`;

export const ImageContainer = styled.div`
  display: block;
  width: 202px;
  height: 278px;
  margin: -64px auto 48px;
  background: ${(p: BackgroundImageProps) =>
    p.backgroundImage && `transparent bottom center url("${p.backgroundImage}") no-repeat;`}
  background-size: cover;

  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    width: 45%;
    height: inherit;
    margin: -32px auto;
    background-size: contain;
  }

  @media (min-width: ${BREAK_POINTS.Min.XL}) {
    max-width: 538px;
    background-position: top center;
    background-size: 62%;
    margin-bottom: -110px;
  }
`;

export const TextContainer = styled.div`
  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    width: 55%;
  }
  @media (min-width: ${BREAK_POINTS.Min.XL}) {
    max-width: 480px;
  }
`;
